import { FunctionComponent, memo, useCallback, useState } from 'react';

import Button, { ButtonSize, ButtonVariant } from '@/components/button';
import OutsideClickWrapper from '@/components/OutsideClickWrapper';
import UserAvatar from '@/components/userAvatar/userAvatar';
import { useAuth } from '@/providers/auth-provider';
import { useModalContext } from '@/providers/ModalProvider';

import OptionsMenu from '../options-menu';
import { useNavigationContext } from '../provider';

interface ProfileOptionsProps {}

const ProfileOptions: FunctionComponent<ProfileOptionsProps> = () => {
  const [areOptionsOpen, setAreOptionsOpen] = useState(false);
  const { isAnonymous, authStateLoading } = useAuth();
  const { openAuthModal } = useModalContext();

  const { aerialMapIsOpen } = useNavigationContext();

  const handleAvatarClick = useCallback(() => {
    if (authStateLoading) return;
    if (isAnonymous) {
      openAuthModal('login');
      return;
    }

    setAreOptionsOpen(!areOptionsOpen);
  }, [areOptionsOpen, authStateLoading, isAnonymous, openAuthModal]);

  return (
    <OutsideClickWrapper
      className="h-full border-b border-b-gray-20"
      onOutsideClick={() => setAreOptionsOpen(false)}
    >
      <>
        <Button
          className="h-full px-2 hover:bg-gray-10 sm:px-4"
          disabled={aerialMapIsOpen}
          size={ButtonSize.XS}
          variant={ButtonVariant.GHOST}
          onClick={handleAvatarClick}
        >
          <UserAvatar />
        </Button>
        <OptionsMenu className="z-[-10]" isOpen={areOptionsOpen} />
      </>
    </OutsideClickWrapper>
  );
};

export default memo(ProfileOptions);
